import { z } from 'zod';

import { BasePType } from './base';
import { PTypes } from './index';

export const baseReusableContent = BasePType.extend({
  type: z.literal('reusableContent'),
});

export type ReusableContent = z.infer<typeof baseReusableContent> & {
  reusableContent?: PTypes[];
};

export const ReusableContent: z.ZodType<ReusableContent> =
  baseReusableContent.extend({
    reusableContent: z.lazy(() => z.array(PTypes)).optional(),
  });
